import React, { useState } from "react";
import "../component/doctorTreatmentHeader.css";

import { FaPlusCircle } from "react-icons/fa";

const DoctorTreatmentHeader = ({
  onAddTreatmentClicked,
  onSearchTreatmentEdited,
}) => {
  const [searchValue, setSearchValue] = useState(
    localStorage.getItem("searchValue")
  );
  const [errorMessage, setErrorMessage] = useState("");

  const handleInputChange = (e) => {
    setSearchValue(e.target.value);
    e.preventDefault();
    if (errorMessage && e.target.value >= 3) {
      setErrorMessage("");
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      localStorage.setItem("searchValue", searchValue);
      e.preventDefault();
      if (searchValue.length > 2) {
        onSearchTreatmentEdited(searchValue);
        setErrorMessage("");
      } else if (searchValue.length === 0) {
        onSearchTreatmentEdited(searchValue);
        setErrorMessage("");
      } else {
        setErrorMessage("Pencarian membutuhkan minimal lebih dari 2 huruf");
      }
    }
  };

  return (
    <div className="doctor-treatment-header-container">
      <button
        className="add-doctor-treatment-button"
        onClick={onAddTreatmentClicked}
      >
        <FaPlusCircle />
        Tambah Tindakan Medis Baru
      </button>

      <div className="search-container">
        <input
          type="text"
          placeholder="Cari Tindakan Medis"
          className="search-input"
          value={searchValue}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
        />
        {errorMessage && <p className="error-message">{errorMessage}</p>}
      </div>
    </div>
  );
};

export default DoctorTreatmentHeader;
